import React from "react";
import RedirectToMap from "../../../../constants/MapConstants";

const GOOGLE_MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.96209080727!2d72.9960694!3d19.065404300000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c120e06e41a9%3A0x4fc46fbed1c4f592!2sDigitMoney%20Technologies%20Private%20Limited!5e0!3m2!1sen!2sin!4v1751711831659!5m2!1sen!2sin";

export const GoogleMapEmbed = () => {
  return (
    <div
    onClick={RedirectToMap}
     className=" w-[90vw] sm:w-full sm:max-w-7xl mx-auto mt-[-3%] mb-5 ">
      <div className="relative w-full h-[90vh] sm:h-[50vh] overflow-hidden rounded-xl shadow-md">
        <iframe
          src={GOOGLE_MAP_EMBED_URL}
          title="DigitMoney Technologies Location"
          className="absolute top-0 left-0 w-full h-full border-0"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};
